import { createContext } from 'react';

import { QRUserRolesTotals } from '@totem/components/services/remoteAccess/v2/totals/types';

interface Context {
  loading: boolean;
  totals: QRUserRolesTotals | null;
  onRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  totals: null,
  onRefresh: () => {},
});
